<template>
    <div class="reports">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">
                    <inertia-link :href="'/backoffice/reports'" class="name">
                        <v-icon color="#921E61" class="mb-1">mdi-arrow-left-circle</v-icon>
                        {{ $page.props.lang.back || "Reports" }}
                    </inertia-link>
               / {{ $page.props.lang.appointmentsMembers || "Appointments members" }}</h2>
            </div>
        </div>
        <div class="table-header">
            <div class="pickers">
                <div class="field-group">
                    <p class="custom-label">{{ $page.props.lang.fromDate || 'From date' }}</p>
                    <v-menu
                    ref="menu"
                    v-model="fromDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="fromDate | formatDate"
                            append-icon="mdi-menu-down" outlined dense hide-details readonly v-bind="attrs" v-on="on" @click:append="fromDatePicker = true"></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="fromDate" :max="toDate"
                        :first-day-of-week="1"  no-title scrollable color="primary">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="fromDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn text color="primary" @click="fromDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <div class="field-group">
                    <p class="custom-label">{{ $page.props.lang.toDate || 'To date' }}</p>
                    <v-menu
                    ref="menu"
                    v-model="toDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="toDate | formatDate"
                            append-icon="mdi-menu-down" outlined dense hide-details readonly v-bind="attrs" v-on="on" @click:append="toDatePicker = true"></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="toDate" :min="fromDate"
                        :first-day-of-week="1" no-title scrollable color="primary">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="toDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn text color="primary" @click="toDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <v-btn @click="filterByDates" color="primary" height="38">{{ $page.props.lang.apply || 'Apply' }}</v-btn>
            </div>
        </div>
        <div class="export-btn">
            <v-tooltip bottom open-delay="400">
                <template v-slot:activator="{on, attrs}">
                    <v-btn @click="exportMembers" color="primary" fab x-small outlined v-bind="attrs" v-on="on">
                        <v-icon>mdi-file-excel-box</v-icon>
                    </v-btn>
                </template>
                <span>{{ $page.props.lang.export || 'Export' }}</span>
            </v-tooltip>
        </div>
        <div class="table-container with-avatar">
            <v-data-table
            :headers="membersHeaders"
            :items="members"
            :page.sync="tablePage"
            @page-count="tablePageCount = $event"
            item-key="item.id"
            mobile-breakpoint="0"
            hide-default-footer>
                <template v-slot:item.first_name="{ item }">
                    <div class="name-medium">
                        <v-avatar size="40">
                            <img :src="item.profile_photo_url + '?w=80'" alt="">
                        </v-avatar>
                        {{ item.first_name }} {{ item.last_name }}
                    </div>
                </template>
                <template v-slot:item.email="{ item }">
                    {{ item.email }}
                </template>
                <template v-slot:item.appointments="{ item }">
                    {{ item.all }}
                </template>
                <template v-slot:item.incomplete="{ item }">
                    {{ item.incomplete }}
                </template>
                <template v-slot:item.canceled="{ item }">
                    {{ item.canceled }}
                </template>
                <template v-slot:item.missing="{ item }">
                    {{ item.missing }}
                </template>
                <template v-slot:item.finished="{ item }">
                    {{ item.finished }}
                </template>
                <template v-slot:item.future="{ item }">
                    {{ item.future }}
                </template>
            </v-data-table>
        </div>
        <v-pagination v-model="tablePage" :length="tablePageCount" class="front-paginate"></v-pagination>
    </div>
</template>


<script>
import AppLayout from '@/js/Layouts/AppLayout'
import moment from 'moment'


export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.title || "Appointments Members"
        }
    },
    layout: AppLayout,
    props: {
        members: Array,
        lang: Object,
        dateFrom: String,
        dateTo: String
    },
    data(){
        return {
            date: moment().format('YYYY-MM-DD'),
             fromDatePicker: false,
            fromDate: moment(this.dateFrom).format('YYYY-MM-DD'),
            toDatePicker: false,
            toDate: moment(this.dateTo).format('YYYY-MM-DD'),
            membersHeaders: [
                {text: this.lang.fullName || 'Full name', value: 'first_name', align: 'start'},
                {text: this.lang.email || 'Email', value: 'email', sortable: false, align: 'center'},
                {text: this.lang.appointments || 'All Appointments', value: 'all', sortable: false, align: 'center'},
                {text: this.lang.incomplete || 'Incomplete', value: 'incomplete', sortable: false, align: 'center'},
                {text: this.lang.canceled || 'Canceled', value: 'canceled', sortable: false, align: 'center'},
                {text: this.lang.missing || 'Missing', value: 'missing', sortable: false, align: 'center'},
                {text: this.lang.finished || 'Finished', value: 'finished', sortable: false, align: 'center'},
                {text: this.lang.future || 'Upcomming', value: 'future', sortable: false, align: 'center'}
            ],
            tablePageCount: 0,
            tablePage: 1
        }
    },
    methods: {
        filterByDates() {
            this.$inertia.visit(
                '/backoffice/reports/appointmentsMembers?dateFrom=' + this.fromDate + '&dateTo=' + this.toDate, 
                {only:['members', 'dateTo', 'dateFrom']}
            )
        },
        exportMembers(){
            window.location.href = '/backoffice/reports/appointmentsMembers/export?dateFrom=' + this.fromDate + '&dateTo=' + this.toDate,
                    {only:['members', 'dateTo', 'dateFrom']}
        }
    }
}

</script>